import React from "react";
import { Typography } from "@mui/material";
import { IDDisplayBox } from "../../../Theme/DigitalTwinStyles";
import { useEntityIdDisplay } from "./entityIdDisplay";

/** "<label>: <value>" box for the selected Advanced Analysis entity. */
const EntityIdDisplayBox = ({ selectedEntity = null, batteryInfo = {} }) => {
    const { label, value } = useEntityIdDisplay(selectedEntity, batteryInfo);
    return (
        <IDDisplayBox sx={{ gap: 0 }} data-testid="advanced-analysis-entity-id">
            <Typography variant="fw400s12c494949">{label}:&nbsp;</Typography>
            <Typography variant="fw400s12c494949">{value}</Typography>
        </IDDisplayBox>
    );
};

export default EntityIdDisplayBox;
